import React from "react";

const YoutubeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_786)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.1171 10.3868C38.8876 9.53889 38.4401 8.76589 37.819 8.14476C37.1979 7.52364 36.4249 7.07605 35.577 6.84658C32.4729 6 19.9799 6 19.9799 6C19.9799 6 7.48627 6.02563 4.38216 6.8722C3.53426 7.10169 2.76127 7.5493 2.14017 8.17046C1.51906 8.79161 1.07152 9.56464 0.842109 10.4126C-0.0968123 15.928 -0.461037 24.3322 0.86789 29.6269C1.09733 30.4748 1.54488 31.2478 2.16598 31.8689C2.78708 32.4901 3.56006 32.9377 4.40795 33.1671C7.51206 34.0137 20.0054 34.0137 20.0054 34.0137C20.0054 34.0137 32.4985 34.0137 35.6025 33.1671C36.4504 32.9377 37.2234 32.4901 37.8446 31.869C38.4657 31.2478 38.9133 30.4748 39.1427 29.6269C40.133 24.1037 40.4382 15.7048 39.1171 10.3869V10.3868Z",
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0034 14.0038V26.0097L26.3675 20.0068L16.0034 14.0038Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_786"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 28.0136,
  fill: "white",
  transform: "translate(0 6)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(YoutubeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;